import {NullableKeys} from '@fl/cmsch-fe-library';

import {Criterias} from './criterias';

/** Redux form name for the bull filter form. */
export const matingBullsFilterFormName = 'matingBullsFilter';

/** Form values used by the bull filter form. */
export type MatingBullsFilterFormValues = NullableKeys<{
    /** Selected organization ids. */
    organizationIds: Array<number>,
    /** Structured criteria filters. */
    criterias: Criterias,
    /** Validation hack used to retrigger redux-form validation. */
    validationHack: number,
}>;

/** Initial bull filter form values. */
export const matingBullsInitialFormValues: MatingBullsFilterFormValues = {
    organizationIds: null,
    criterias: null,
    validationHack: null,
};
